// extracted by mini-css-extract-plugin
export default {"speedDial":"src-feature-ui-floating-action-__floating-action_speedDial"};